// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"270":"0f2312ae","651":"9320ff01"}[chunkId] + ".chunk.css";
};